import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import 'font-awesome/css/font-awesome.min.css';

export default function Contact() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const handleSubmitFeedback = async (e) => {
    e.preventDefault();

    if (isSubmitting) return; // ✅ GUARD CLAUSE TO PREVENT DOUBLE SUBMIT

    setIsSubmitting(true);
    try {
      // Add your form submission logic here
      await new Promise(resolve => setTimeout(resolve, 1000)); // Simulate API call
      setFormData({ name: '', email: '', message: '' });
      alert('Thank you! Your message has been sent.');
    } catch (error) {
      console.error('Error submitting form:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{
      background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)",
      color: "#333",
      minHeight: "100vh",
      fontFamily: "'Poppins', Arial, sans-serif",
      padding: "40px 20px"
    }}>
      <div style={{
        maxWidth: "1000px",
        margin: "0 auto"
      }}>
        {/* Header with Back Button */}
        <div style={{ marginBottom: "30px" }}>
          <Link to="/" style={{
            display: "inline-flex",
            alignItems: "center",
            color: "#4caf50",
            textDecoration: "none",
            fontSize: "1.1rem",
            background: "#f0f9f0",
            padding: "8px 16px",
            borderRadius: "8px",
            transition: "all 0.3s ease"
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "#4caf50";
            e.target.style.color = "white";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "#f0f9f0";
            e.target.style.color = "#4caf50";
          }}>
            <i className="fa fa-arrow-left" style={{ marginRight: "10px" }} />
            Back to Home
          </Link>
        </div>

        {/* Main Content - Full width contact info */}
        <div style={{
          background: "#ffffff",
          borderRadius: "16px",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.05)",
          border: "1px solid rgba(76, 175, 80, 0.1)",
          overflow: "hidden"
        }}>
          {/* Header Section */}
          <div style={{
            background: "linear-gradient(135deg, #4caf50 0%, #45a049 100%)",
            padding: "60px 40px",
            color: "white",
            textAlign: "center"
          }}>
            <h1 style={{
              fontSize: "3rem",
              marginBottom: "20px",
              fontWeight: "600"
            }}>
              Contact Us
            </h1>
            <p style={{
              fontSize: "1.2rem",
              lineHeight: "1.6",
              opacity: "0.9",
              maxWidth: "600px",
              margin: "0 auto"
            }}>
              Have questions about V-EDITOR? Want to collaborate or just say hello? 
              We'd love to hear from you!
            </p>
          </div>

          {/* Contact Info Cards Grid */}
          <div style={{ padding: "60px 40px" }}>
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              gap: "30px",
              marginBottom: "40px"
            }}>
              {/* Email Card */}
              <div style={{
                background: "#f8f9fa",
                padding: "30px",
                borderRadius: "12px",
                textAlign: "center",
                border: "1px solid #e2e8f0",
                transition: "all 0.3s ease"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 10px 25px rgba(76, 175, 80, 0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "none";
              }}>
                <div style={{
                  width: "70px",
                  height: "70px",
                  background: "linear-gradient(135deg, #4caf50 0%, #45a049 100%)",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px"
                }}>
                  <i className="fa fa-envelope" style={{ fontSize: "30px", color: "white" }} />
                </div>
                <h3 style={{ fontSize: "1.5rem", color: "#2d3748", marginBottom: "10px" }}>Email</h3>
                <p style={{ color: "#718096", marginBottom: "15px" }}>Send us an email anytime</p>
                <a href="mailto:veditort@gmail.com" style={{
                  color: "#4caf50",
                  textDecoration: "none",
                  fontSize: "1.1rem",
                  fontWeight: "500"
                }}>
                  veditort@gmail.com
                </a>
              </div>

              {/* Twitter Card */}
              <div style={{
                background: "#f8f9fa",
                padding: "30px",
                borderRadius: "12px",
                textAlign: "center",
                border: "1px solid #e2e8f0",
                transition: "all 0.3s ease"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 10px 25px rgba(76, 175, 80, 0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "none";
              }}>
                <div style={{
                  width: "70px",
                  height: "70px",
                  background: "linear-gradient(135deg, #4caf50 0%, #45a049 100%)",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px"
                }}>
                  <i className="fa fa-twitter" style={{ fontSize: "30px", color: "white" }} />
                </div>
                <h3 style={{ fontSize: "1.5rem", color: "#2d3748", marginBottom: "10px" }}>Twitter</h3>
                <p style={{ color: "#718096", marginBottom: "15px" }}>Follow us for updates</p>
                <a href="https://twitter.com/veditor" target="_blank" rel="noopener noreferrer" style={{
                  color: "#4caf50",
                  textDecoration: "none",
                  fontSize: "1.1rem",
                  fontWeight: "500"
                }}>
                  
                </a>
              </div>

              {/* GitHub Card */}
              <div style={{
                background: "#f8f9fa",
                padding: "30px",
                borderRadius: "12px",
                textAlign: "center",
                border: "1px solid #e2e8f0",
                transition: "all 0.3s ease"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 10px 25px rgba(76, 175, 80, 0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "none";
              }}>
                <div style={{
                  width: "70px",
                  height: "70px",
                  background: "linear-gradient(135deg, #4caf50 0%, #45a049 100%)",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px"
                }}>
                  <i className="fa fa-github" style={{ fontSize: "30px", color: "white" }} />
                </div>
                <h3 style={{ fontSize: "1.5rem", color: "#2d3748", marginBottom: "10px" }}>GitHub</h3>
                <p style={{ color: "#718096", marginBottom: "15px" }}>Check our repositories</p>
                <a href="https://github.com" target="_blank" rel="noopener noreferrer" style={{
                  color: "#4caf50",
                  textDecoration: "none",
                  fontSize: "1.1rem",
                  fontWeight: "500"
                }}>
                  
                </a>
              </div>
            </div>

            {/* Additional Info Cards */}
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "20px",
              marginTop: "20px"
            }}>
              {/* Response Time Card */}
              <div style={{
                background: "#f8f9fa",
                padding: "20px",
                borderRadius: "10px",
                border: "1px solid #e2e8f0",
                display: "flex",
                alignItems: "center",
                gap: "15px"
              }}>
                <i className="fa fa-clock-o" style={{ fontSize: "30px", color: "#4caf50" }} />
                <div>
                  <h4 style={{ color: "#2d3748", marginBottom: "5px" }}>Response Time</h4>
                  <p style={{ color: "#718096" }}>Within 24-48 hours</p>
                </div>
              </div>

              {/* Guest Friendly Card */}
              <div style={{
                background: "#f8f9fa",
                padding: "20px",
                borderRadius: "10px",
                border: "1px solid #e2e8f0",
                display: "flex",
                alignItems: "center",
                gap: "15px"
              }}>
                <i className="fa fa-user-circle" style={{ fontSize: "30px", color: "#4caf50" }} />
                <div>
                  <h4 style={{ color: "#2d3748", marginBottom: "5px" }}>Guest Friendly</h4>
                  <p style={{ color: "#718096" }}>No account required</p>
                </div>
              </div>

              {/* Bug Reports Card */}
              <div style={{
                background: "#f8f9fa",
                padding: "20px",
                borderRadius: "10px",
                border: "1px solid #e2e8f0",
                display: "flex",
                alignItems: "center",
                gap: "15px"
              }}>
                <i className="fa fa-bug" style={{ fontSize: "30px", color: "#4caf50" }} />
                <div>
                  <h4 style={{ color: "#2d3748", marginBottom: "5px" }}>Report a Bug</h4>
                  <p style={{ color: "#718096" }}>Email us with details</p>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <form onSubmit={handleSubmitFeedback} style={{
              marginTop: "40px",
              padding: "30px",
              background: "#f8f9fa",
              borderRadius: "10px",
              border: "1px solid #e2e8f0"
            }}>
              <h3 style={{ color: "#2d3748", marginBottom: "20px" }}>Send us a message</h3>
              
              <div style={{ marginBottom: "20px" }}>
                <label style={{ display: "block", color: "#2d3748", marginBottom: "8px", fontWeight: "500" }}>Name</label>
                <input
                  type="text"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "8px",
                    border: "1px solid #e2e8f0",
                    fontSize: "1rem"
                  }}
                />
              </div>

              <div style={{ marginBottom: "20px" }}>
                <label style={{ display: "block", color: "#2d3748", marginBottom: "8px", fontWeight: "500" }}>Email</label>
                <input
                  type="email"
                  required
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "8px",
                    border: "1px solid #e2e8f0",
                    fontSize: "1rem"
                  }}
                />
              </div>

              <div style={{ marginBottom: "20px" }}>
                <label style={{ display: "block", color: "#2d3748", marginBottom: "8px", fontWeight: "500" }}>Message</label>
                <textarea
                  required
                  rows="5"
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "8px",
                    border: "1px solid #e2e8f0",
                    fontSize: "1rem",
                    fontFamily: "inherit"
                  }}
                />
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                style={{
                  background: isSubmitting ? "#95a5a6" : "#4caf50",
                  color: "white",
                  padding: "12px 30px",
                  borderRadius: "8px",
                  border: "none",
                  fontSize: "1rem",
                  fontWeight: "500",
                  cursor: isSubmitting ? "not-allowed" : "pointer",
                  transition: "all 0.3s ease"
                }}>
                {isSubmitting ? "Sending..." : "Send Message"}
              </button>
            </form>

            {/* Guest Notice */}
            <div style={{
              marginTop: "40px",
              padding: "20px",
              background: "#f0f9f0",
              borderRadius: "10px",
              border: "1px solid #c3e6cb",
              textAlign: "center"
            }}>
              <i className="fa fa-lock" style={{ color: "#4caf50", marginRight: "10px" }} />
              <span style={{ color: "#2d3748" }}>
                <strong>Guest friendly:</strong> No account needed to contact us. All inquiries welcome!
              </span>
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div style={{
          marginTop: "40px",
          background: "#ffffff",
          borderRadius: "16px",
          padding: "40px",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.05)",
          border: "1px solid rgba(76, 175, 80, 0.1)"
        }}>
          <h2 style={{
            fontSize: "1.8rem",
            color: "#2d3748",
            marginBottom: "30px",
            textAlign: "center"
          }}>
            Frequently Asked Questions
          </h2>
          
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "20px"
          }}>
            <div style={{
              padding: "20px",
              background: "#f8f9fa",
              borderRadius: "10px",
              border: "1px solid #e2e8f0"
            }}>
              <h3 style={{
                color: "#2d3748",
                marginBottom: "10px",
                display: "flex",
                alignItems: "center",
                gap: "10px"
              }}>
                <i className="fa fa-clock-o" style={{ color: "#4caf50" }} />
                Response Time?
              </h3>
              <p style={{ color: "#718096", fontSize: "0.95rem" }}>
                We typically respond within 24-48 hours on business days.
              </p>
            </div>

            <div style={{
              padding: "20px",
              background: "#f8f9fa",
              borderRadius: "10px",
              border: "1px solid #e2e8f0"
            }}>
              <h3 style={{
                color: "#2d3748",
                marginBottom: "10px",
                display: "flex",
                alignItems: "center",
                gap: "10px"
              }}>
                <i className="fa fa-user-circle" style={{ color: "#4caf50" }} />
                Need an Account?
              </h3>
              <p style={{ color: "#718096", fontSize: "0.95rem" }}>
                No! You can contact us as a guest without any registration.
              </p>
            </div>

            <div style={{
              padding: "20px",
              background: "#f8f9fa",
              borderRadius: "10px",
              border: "1px solid #e2e8f0"
            }}>
              <h3 style={{
                color: "#2d3748",
                marginBottom: "10px",
                display: "flex",
                alignItems: "center",
                gap: "10px"
              }}>
                <i className="fa fa-bug" style={{ color: "#4caf50" }} />
                Found a Bug?
              </h3>
              <p style={{ color: "#718096", fontSize: "0.95rem" }}>
                Please include steps to reproduce and your browser info.
              </p>
            </div>

            <div style={{
              padding: "20px",
              background: "#f8f9fa",
              borderRadius: "10px",
              border: "1px solid #e2e8f0"
            }}>
              <h3 style={{
                color: "#2d3748",
                marginBottom: "10px",
                display: "flex",
                alignItems: "center",
                gap: "10px"
              }}>
                <i className="fa fa-handshake-o" style={{ color: "#4caf50" }} />
                Partnerships?
              </h3>
              <p style={{ color: "#718096", fontSize: "0.95rem" }}>
                Email us at veditort@gmail.com for collaboration.
              </p>
            </div>
          </div>
        </div>

        {/* Quick Links */}
        <div style={{
          marginTop: "40px",
          display: "flex",
          justifyContent: "center",
          gap: "30px",
          flexWrap: "wrap",
          background: "#ffffff",
          padding: "30px",
          borderRadius: "16px",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.05)",
          border: "1px solid rgba(76, 175, 80, 0.1)"
        }}>
          <Link to="/terms" style={{
            color: "#4a5568",
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "8px 16px",
            borderRadius: "8px",
            transition: "all 0.3s ease",
            background: "#f8f9fa"
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "#4caf50";
            e.target.style.color = "white";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "#f8f9fa";
            e.target.style.color = "#4a5568";
          }}>
            <i className="fa fa-file-text" /> Terms & Conditions
          </Link>
          
          <Link to="/privacy" style={{
            color: "#4a5568",
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "8px 16px",
            borderRadius: "8px",
            transition: "all 0.3s ease",
            background: "#f8f9fa"
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "#4caf50";
            e.target.style.color = "white";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "#f8f9fa";
            e.target.style.color = "#4a5568";
          }}>
            <i className="fa fa-shield-alt" /> Privacy Policy
          </Link>
          
          <Link to="/" style={{
            color: "#4a5568",
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "8px 16px",
            borderRadius: "8px",
            transition: "all 0.3s ease",
            background: "#f8f9fa"
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "#4caf50";
            e.target.style.color = "white";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "#f8f9fa";
            e.target.style.color = "#4a5568";
          }}>
            <i className="fa fa-home" /> Home
          </Link>
        </div>

        {/* Footer */}
        <footer style={{
          marginTop: "40px",
          textAlign: "center",
          color: "#718096",
          fontSize: "0.8rem",
          padding: "20px"
        }}>
          <p>© {new Date().getFullYear()} V-EDITOR. All rights reserved.</p>
          <p style={{ 
            marginTop: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "5px"
          }}>
            <i className="fa fa-user-circle" style={{ color: "#4caf50" }} />
            Guest friendly • No account required
          </p>
          <p style={{ marginTop: "10px", color: "#4caf50", fontWeight: "500" }}>
            Code. Chat. Collaborate.
          </p>
        </footer>
      </div>
    </div>
  );
}